import React, { useState, useEffect,useContext } from "react";
import { Row, Col, Card, Table, Alert, ProgressBar, Spinner } from "react-bootstrap";
import axios from "axios";
import _ from "lodash";
import Utils from "./../../common/Utils";
import ChoosePlans from "../../components/application/ChoosePlans";
import { UserContext } from "../../common";

const Dashboard = (props) => {
  const { userData } = useContext(UserContext);
  const [jobStat, setJobStat] = useState({ loading: false, stats: [] });
  const [taskStat, setTaskStat] = useState({ loading: false, stats: [] });
  const [summary, setSummary] = useState({
    loading: false,
    records: [],
    st: 0,
    total: 0,
  });

  const fetchJobStats = () => {
    setJobStat({ ...jobStat, loading: true });
    axios
      .get(Utils.apiUrl("jobs/fetchstats"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setJobStat({ loading: false, stats: res.data.stats });
          Utils.addToUserData({ jobs: res.data.stats[1] });
        } else {
          setJobStat({ ...jobStat, loading: false });
        }
      })
      .catch((err) => {
        setJobStat({ ...jobStat, loading: false });
        console.log(err);
      });
  };

  const fetchTaskStats = () => {
    setTaskStat({ ...taskStat, loading: true });
    axios
      .get(Utils.apiUrl("tasks/fetchstats"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setTaskStat({ loading: false, stats: res.data.stats });
          Utils.addToUserData({ tasks: res.data.stats[1] });
        } else {
          setTaskStat({ ...taskStat, loading: false });
        }
      })
      .catch((err) => {
        setTaskStat({ ...taskStat, loading: false });
        console.log(err);
      });
  };

  const fetchTeamSummary = (st = 0) => {
    setSummary({ ...summary, loading: true });
    axios
      .get(Utils.apiUrl(`jobs/fetchteamsummary?pp=${Utils.perpage}&st=${st}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          var tmp = {
            ...summary,
            loading: false,
            records: res.data.records,
            st: st,
          };
          if (_.get(res, "data.total", false)) {
            tmp["total"] = res.data.total;
          }
          setSummary(tmp);
        } else {
          setSummary({ ...summary, loading: false });
        }
      })
      .catch((err) => {
        setSummary({ ...summary, loading: false });
        console.log(err);
      });
  };

  const showPagination = ({ loading, st, total }, callback) => {
    var pp = Utils.perpage;
    if (loading || (st === 0 && st + pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {st + pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {st + pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => callback(st + pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {st >= pp && (
            <div className="clickable text-clickable" onClick={() => callback(st - pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {st == 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };

  useEffect(fetchJobStats, []);
  useEffect(fetchTaskStats, []);
  useEffect(fetchTeamSummary, []);

  const goto = (path) => (e) => {
    window.location.href = process.env.PUBLIC_URL + path;
  };

  if (!Utils.hasAccess(1)) {
    return (
      <>
        <h1 class=" text-center alert-success p-5 mt-5">Welcome to Denttrack</h1>      
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <div>
      {/*<Row className="mt-4">
                <Col>
                    <Card border="danger" className="shadow">
                        <Card.Body>
                            <Card.Text className="alert p-0">you are a day late to send MIS report for the month of june</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>*/}
      {Utils.hasAccess(3) && (
        <Row className="mt-0 mt-sm-4">
          <Col>
            <Card border="light" className="shadow dashboardStats">
              <Card.Body>
                <Row>
                  <Col xs="12" lg="3">
                    <span className="d-flex justify-content-center align-items-center h-100">
                      <span className="title">Jobs</span>
                      {jobStat.loading && <Spinner animation="border" className="ms-4" />}
                    </span>
                  </Col>
                  <Col xs="4" lg="3">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/jobs/delayed")} title="Delayed Jobs">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/delayed.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(jobStat, "stats.0", "0")} <span className="d-block subtitle">Delayed</span> <small>(Till date)</small>
                      </span>
                    </span>
                  </Col>
                  <Col xs="4" lg="3">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/jobs/upcoming")} title="Upcoming Jobs">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/upcoming.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(jobStat, "stats.1", "0")} <span className="d-block subtitle">Upcoming</span>
                        <small>(Today)</small>
                      </span>
                    </span>
                  </Col>
                  <Col xs="4" lg="3">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/jobs/complete")} title="Completed Jobs">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/completed.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(jobStat, "stats.2", "0")} <span className="d-block subtitle">Complete</span>
                        <small>(This Week)</small>
                      </span>
                    </span>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {Utils.hasAccess(4) && (
        <Row className="mt-4">
          <Col>
            <Card border="light" className="shadow dashboardStats">
              <Card.Body>
                <Row>
                  <Col xs="12" lg="3">
                    <span className="d-flex justify-content-center align-items-center h-100">
                      <span className="title">Tasks</span>
                      {taskStat.loading && <Spinner animation="border" className="ms-4" />}
                    </span>
                  </Col>
                  <Col xs="3" lg="2">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/todo/delayed")} title="Delayed Tasks">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/delayed.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(taskStat, "stats.0", "0")} <span className="d-block subtitle">Delayed</span> <small>(Till date)</small>
                      </span>
                    </span>
                  </Col>
                  <Col xs="3" lg="2">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/todo/upcoming")} title="Upcoming Tasks">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/upcoming.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(taskStat, "stats.1", "0")} <span className="d-block subtitle">Upcoming</span>
                        <small>(Today)</small>
                      </span>
                    </span>
                  </Col>
                  <Col xs="3" lg="2">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/todo/complete")} title="Completed Tasks">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/completed.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(taskStat, "stats.2", "0")} <span className="d-block subtitle">Complete</span>
                        <small>(This Week)</small>
                      </span>
                    </span>
                  </Col>
                  <Col xs="3" lg="3">
                    <span className="d-flex justify-content-center clickable" onClick={goto("/todo/upcoming30days")} title="Upcoming 30 Days Tasks">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/upcoming30days.png`}
                        width="50"
                        height="50"
                        className="d-inline-block align-top me-2"
                        alt=""
                      />
                      <span className="title">
                        {_.get(taskStat, "stats.3", "0")} <span className="d-block subtitle">Upcoming</span>
                        <small>(30 Days)</small>
                      </span>
                    </span>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {Utils.hasAccess(3) && (
        <Row className="mt-3">
          <Col>
            <h3 className="title ps-1">Team's Summary</h3>
            <Card border="light" className="shadow table-section p-lg-2 mt-2">
              <Card.Body>
                {summary.loading && (
                  <Alert variant="success" className="p-3">
                    <p className="loading-msg">Fetching team's summary.. </p>
                    <ProgressBar variant="success" animated now={100} />
                  </Alert>
                )}
                {!summary.loading && (
                  <>
                    {summary.total === 0 && (
                      <Alert variant="warning" className="p-3">
                        <b>No Team's Summary found!</b>
                      </Alert>
                    )}
                    {summary.total > 0 && (
                      <Table striped hover responsive className="text-nowrap">
                        <thead>
                          <tr>
                            <th width="100" className="d-none d-sm-table-cell">
                              Sr. No.
                            </th>
                            <th>Name</th>
                            <th className="d-none d-sm-table-cell">Role</th>
                            <th>Branch Name</th>
                            <th width="100" className="text-center">
                              Jobs
                              <br />
                              Complete
                            </th>
                            <th width="100" className="text-center">
                              Jobs
                              <br />
                              Overdue
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {summary.records.map((r, idx) => (
                            <tr key={idx}>
                              <td className="text-center d-none d-sm-table-cell">{Utils.addZero(summary.st + idx + 1)}.</td>
                              <td>{r.name}</td>
                              <td className="d-none d-sm-table-cell">{r.designation}</td>
                              <td>{r.bname}</td>
                              <td className="text-center">{r.completed}</td>
                              <td className="text-center">{r.backlog}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}

                    {showPagination(summary, fetchTeamSummary)}
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};
export default Dashboard;
